import React from 'react';
import { EasyText, EasyWrapper, Title, TitleUnderlineSvg, TitleUnderlineWrap } from './styles';

type Props = {
  isUnderlineVisible: boolean;
};

const ProcessBlockTitle: React.FC<Props> = ({ isUnderlineVisible }) => (
  <Title id="referral-process-title">
    We make the process{' '}
    <EasyWrapper>
      <EasyText>easy</EasyText>
      <TitleUnderlineWrap>
        <TitleUnderlineSvg
          viewBox="0 0 128 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
          $isVisible={isUnderlineVisible}
        >
          <path
            d="M1.63892 4.5105C1.78905 4.5105 1.93918 4.5105 10.9493 4.42302C19.9595 4.33554 37.8251 4.16058 49.7309 3.85175C61.6368 3.54292 67.0415 3.10552 79.8845 2.61775C92.7276 2.12999 112.845 1.60511 121.257 1.64089C129.669 1.67668 125.766 2.28904 117.449 3.21686C109.133 4.14468 96.5218 5.3694 85.5963 6.78763C74.6709 8.20587 65.8132 9.78051 60.9498 10.6792C54.4168 12.108 49.599 13.513 46.2301 14.5376C45.7729 14.6714 45.3225 14.7589 43.9486 15.1141"
            stroke="#EB6424"
            strokeLinecap="round"
            strokeWidth="3.27791"
          />
        </TitleUnderlineSvg>
      </TitleUnderlineWrap>
    </EasyWrapper>
    .
  </Title>
);

export default ProcessBlockTitle;
